import React from "react"

const ActivityPlan = ({ tripId = undefined }) => {
  return <div>Activity Plan - {tripId}</div>
}

export default ActivityPlan
